import { LAYOUTS, MODULE_SETTINGS, STAFF_ROLES } from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { PORTFOLIO_ROUTE_NAMES } from "portfolio/routes/routeNames";

/**
 * Portfolio route fragment for /my-students/portfolio
 * Import and spread into myStudentsRoutes.js children array.
 */
export const myStudentsPortfolioFragment: AppRouteRecordRaw[] = [
  {
    path: "portfolio",
    name: PORTFOLIO_ROUTE_NAMES.MY_STUDENTS,
    component: () => import("portfolio/pages/MyStudentsPortfolioPage.vue"),
    meta: {
      title: "Portfolio",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [MODULE_SETTINGS.PORTFOLIO],
      roleRequired: STAFF_ROLES,
      layout: LAYOUTS.MAIN_NO_WRAPPER,
    },
  },
];
